// let url = window.location.href
// let urlObj = new URL(url)
// let host = urlObj.hostname
// let scheme = urlObj.protocol

const warehouseId = process.env.VUE_APP_WAREHOUSE_ID
const masterApi = process.env.VUE_APP_MASTER_API
const config = {
  vuexStorageKeys: [
    'sessionToken'
  ],
  plugins: [
    'tk',
    'device',
    'vuexStorage',
    'index',
    'user',
    'warehouseAdmin',
    'routerAuth'
  ],
  navTheme: 'light', // 导航主题: dark 或 lighty
  layoutMode: 'sidemenu', // 布局类型：sidemenu 或 topmenu
  contentWidth: 'Fluid', // 内容布局类型，Fluid 或 Fixed
  fixedHeader: true, // 是否固定头部
  fixSidebar: true, // 是否固定左侧导航栏
  projectName: 'AI测虫',
  internalApi: false,
  apiUrl: masterApi,
  appID: 'no appid',
  masterKey: 'no masterKey',
  restKey: '',
  warehouseId: warehouseId && warehouseId.length === 10 ? warehouseId : null,
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon')
}
export default config
